import { LitElement, html, nothing } from 'lit';

import { ref } from 'lit/directives/ref.js';

const { 
  convertFormDataToObject, 
  convertObjectToFormData, 
  wait,
} = require('../utilities/utils');

export default class WhiskersForm extends LitElement {

  // Avoid shadow DOM
  createRenderRoot() {
    return this;
  }

  static get properties() {
    return {
      // Form attributes
      method: { type: String },
      action: { type: String },
      enctype: { type: String },
      headers: { type: Object },

      // Validation
      externalFieldErrors: { type: Object },
      externalFormErrors: { type: Array },

      // State
      busy: { type: Boolean }, // show a spinner and reject submits
    };
  }

  constructor() {
    super();

    // Initialise form errors
    this.externalFieldErrors = {};
    this.externalFormErrors = [];
  }

  firstUpdated() {
    const form = this.querySelector('form');
    const children = Array.from(this.children).filter(child => child.tagName !== 'FORM');

    children.reverse().forEach(child => {
      form.prepend(child);
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    console.log('submit', e);
    console.log(this.headers);
    console.log(this.form);

    // Return early if form is already submitting
    if (this.busy) {
      console.warn('Take a break, kiddo');
      return;
    }

    this.busy = true;

    const [sendResponse] = await Promise.all([
      this.sendFormData(),
      wait(2000),
    ]);
    const sendResult = this.interpretResponse(sendResponse);
    console.log('sendResult', sendResult);

    this.busy = false;

    return false;
  }

  interpretResponse(response) {
    const { success, errors, results } = response;

    if (![true, false].includes(success)) {
      // We received a non-standard response, treat as an error
      this.externalFormErrors = [`Something went wrong, please try again.`];
      this.externalFieldErrors = {};
      return false;
    }
    // We received a standardised response
    
    if (success) {
      // Success
      this.externalFormErrors = [];
      this.externalFieldErrors = {};
      return true;
    }
    
    // Error
    let externalFieldErrors = {};
    let externalFormErrors = [];

    for (const error of errors) {
      const { field, message } = error;

      const errorMessage = message || error;

      // If no field, it's a general error
      if (!field) {
        externalFormErrors.push(errorMessage);
        continue;
      }

      if (Array.isArray(field)) {
        field.forEach(f => {
          externalFieldErrors[f] = errorMessage;
        });
        continue;
      }

      externalFieldErrors[field] = errorMessage;
    }

    this.externalFieldErrors = externalFieldErrors;
    this.externalFormErrors = externalFormErrors;

    return false;
  }

  async sendFormData() {
    const form = this.form;
    const formData = new FormData(form);

    let headers = this.headers;
    let body;

    const formEnctype = form.getAttribute('enctype') || form.enctype;
    switch (formEnctype) {
      case 'multipart/form-data':
        body = formData;
        break;
      case 'application/x-www-form-urlencoded':
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        body = new URLSearchParams(formData);
        break;
      case 'application/json':
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(convertFormDataToObject(formData));
        break;
      default:
        console.warn(`Unrecognised enctype: ${ formEnctype }?`);
        return false;
    }
    
    try {
      const result = await fetch(form.action, {
        method: form.method,
        headers,
        body,
      });

      const data = await result.json();
      console.log(data);
      return data;

    } catch(err) {
      console.log(err);
    }
    
    return false;
  }

  render() {
    return html`
      <form 
        ${ ref((el) => (this.form = el)) }
        .action=${ this.action || '' }
        .method=${ this.method || '' }
        .enctype=${ this.enctype || '' }
        @submit=${ this.handleSubmit }
        ?disabled=${ this.busy }
      >
        <button 
          type="submit" 
          ?disabled=${ this.busy }
        >
          ${ this.busy ? '...' : 'Submit' }
        </button>

        <p class="whisker_form_errors">${ this.externalFormErrors.join(', ') }</p>

      </form>
    `;
  }
}

window.customElements.get('whiskers-form') ||
  window.customElements.define('whiskers-form', WhiskersForm);
